import React from 'react';
//import Button from "../../components/CustomButtons/Button";
import Button from "@material-ui/core/Button";
import API from 'components/44/ApiPlanungswelten';

class OpenAiTextgenerator44 extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      description: ''
    }

    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  handleDescriptionChange(){
    let data = this.props.data;

    const zuLoeschendeKeys = ['images', '*energiepass'];

    // Funktion zum Überprüfen, ob ein Schlüssel gelöscht werden sollte
    const shouldDeleteKey = (key) => {
      return zuLoeschendeKeys.some(pattern => {
        if (pattern.startsWith('*') && pattern.endsWith('*')) {
          return key.includes(pattern.substring(1, pattern.length - 1));
        } else if (pattern.startsWith('*')) {
          return key.endsWith(pattern.substring(1));
        } else if (pattern.endsWith('*')) {
          return key.startsWith(pattern.substring(0, pattern.length - 1));
        } else {
          return key === pattern;
        }
      });
    };

    // Erstellen eines neuen bereinigten Datenobjekts
    const bereinigtesData = {};
    for (const key in data) {
      if (!shouldDeleteKey(key)) {
        if(key === 'material_auswahl'){
          console.debug('material_auswahl', data[key])
          console.debug('material_auswahl: typeof: ', typeof data[key])
          console.debug('material_auswahl', Object.keys(data[key])[0])
        }
        /*
         * Wert umformen, weil manche Keys wie material_auswahl liefern ein object mit einem Wert
         * wie z.B.: data[materialauswahl][Aluminium]=true
         */
        if(typeof data[key] === 'object') {
          bereinigtesData[key] = Object.keys(data[key])[0] || ''
        }else{
          bereinigtesData[key] = data[key];
        }
      }
    }

    data = bereinigtesData;

    console.log('handleDescriptionChange: props.data', data);

    const generateDescription = async () => {

      try {
        const response = await API.generateAiText(data);
        //console.log('response', response);
        this.setDescription(response);

      } catch (error) {
        console.error('Fehler beim Generieren der Beschreibung:', error);
        this.setDescription('Fehler beim Generieren der Beschreibung!');
      }
    };

    generateDescription();
  }

  setDescription(text){
    this.setState({ description: text });
    if (this.props.onChange) {
      this.props.onChange(text);
    }
  }

  render() {
    const { variant, style, children } = this.props;

    return (
      <div>
        <Button variant={variant} style={style} onClick={this.handleDescriptionChange}>{children}</Button>
        <small style={{paddingLeft:10, marginTop: 6, position:'absolute'}}>Beachten Sie, dass das Ergebnis umso besser wird, je mehr Attribute (Kategorie, Name, Hersteller, Modell, Art, Extras, Farbe, Maße, Material) gefüllt sind.</small>
      </div>
    );
  }

}

export default OpenAiTextgenerator44;
